module.exports = __webpack_public_path__ + "static/media/lottery3.8c3cf548.png";